import React from 'react';
import { withHydrate } from '@ecommerce/nest-ssr/common';

import LayoutDesktop from '../../layouts/layout/layout.desktop';
import MainCompanyReviews from 'components/main/main-reviews/main-company-reviews';
import MainProductReviews from 'components/main/main-reviews/main-product-reviews';
import PartnersGrid from 'components/partners/partners-grid';
import MainReviews from 'components/main/main-reviews/main-reviews';
import MainBannerDesktop from 'components/main/banner/main-banner.desktop';
import MainRankingsDesktop from 'components/main/rankings/main-rankings.desktop';

const MainPageDesktop: React.FC = () => (
    <LayoutDesktop isHomepage={true}>
        <MainBannerDesktop />
        <div className="rankings container">
            <MainRankingsDesktop className="rankings-slider" />
        </div>
        <MainReviews title="Ostatnie opinie o sklepach i firmach" className="reviews-companies">
            <MainCompanyReviews />
        </MainReviews>
        <MainReviews title="Ostatnie opinie o produktach" className="reviews-products">
            <MainProductReviews />
        </MainReviews>
        <PartnersGrid />
    </LayoutDesktop>
);

export default withHydrate(MainPageDesktop, { root: '#root' }, 'views/pages/main/main.desktop');
